// TODO: Replace this hard-coded state with nodeType providers and empty defaults

export default {
  authors: [],
  apiKey: '',
  description: '',
  license: '',
  name: '',
  version: '0.0.0',
  patches: {
    '@/main': {
      attachments: [],
      comments: {},
      description: '',
      links: {},
      nodes: {},
      path: '@/main',
    },
  },
};



// WEBPACK FOOTER //
// ../../src/project/state.js